import React from "react";
import { Label } from "../Label";
import { concatStringFromClassesArrayList, sanitiseString } from "../../Utils";

export interface Props {
  id: string;
  name?: string;
  value?: string;
  classes?: string;
  inputClasses?: string;
  checked?: boolean;
  disabled?: boolean;
  label: React.ComponentProps<typeof Label>;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  dataTestId?: string;
}

export const RadioInput = (props: Props) => {
  const radioClassList = {
    defaultClass: "ons-radio",
    optionalClasses: [props.classes || null],
  };
  const radioClassName = concatStringFromClassesArrayList(radioClassList);

  const radioInputClassList = {
    defaultClass: "ons-radio__input",
    optionalClasses: [props.inputClasses || null],
  };
  const radioInputClassName =
    concatStringFromClassesArrayList(radioInputClassList);

  const radioLabelClassList = {
    defaultClass: "ons-radio__label",
    optionalClasses: [props.label.classes || null],
  };
  const radioLabelClassName =
    concatStringFromClassesArrayList(radioLabelClassList);

  const sanitisedId = sanitiseString(props.id);
  const sanitisedDataTestId = sanitiseString(props.dataTestId);

  return (
    <span className={radioClassName} data-testid={sanitisedDataTestId}>
      <input
        type="radio"
        id={sanitisedId}
        className={radioInputClassName}
        checked={props.checked}
        {...(props.value ? { value: props.value } : {})}
        {...(props.name ? { name: props.name } : {})}
        {...(props.disabled ? { disabled: true, "aria-disabled": "true" } : {})}
        onClick={(e) => props.onClick !== undefined && props.onClick(e)}
        onChange={(e) => props.onChange !== undefined && props.onChange(e)}
        data-testid={`${sanitisedDataTestId}-input`}
      />

      <Label
        id={`${sanitisedId}-label`}
        for={sanitisedId}
        inputType="radio"
        text={props.label.text}
        classes={radioLabelClassName}
        description={props.label.description}
        iconType={props.label.iconType}
        dataTestId={sanitisedDataTestId}
      />
    </span>
  );
};
